import { createAction, handleActions } from 'redux-actions';
import { useRedux } from 'util/hook/redux';

/* 若需客製化 api 時可以引入如： { api, customGRApi } 其中 customGRApi 在 'util/api'做設定 */
import { api } from 'util/api';

/**
 * 這邊需注意 swagger schema 回來的 data-contracts 內的 v1WebEventsList return 型別
 * 為 EventShowResource [], 實際上 api 卻是 EventShowResource
 * 不確定是否為 swagger schema 沒有跟著調整所導致, 若有再次進行 API library 的 yarn api:create
 * 可能就需要重新檢查這個型別, 因目前 store 設定（event 內頁 getEvent, init state）
 * 都以 EventShowResource 為主 若沒檢查可能接起來在頁面上使用會出錯
 */
import {
	EventResource,
	EventShowResource,
	GrModalResource,
} from 'util/api/swaggerApi/data-contracts';
import { State as GlobalState } from './reducers';

export const getEvents = createAction('GET_EVENTS', async () => {
	try {
		const { v1WebEventsList } = api;
		const data = await v1WebEventsList();

		const resultArray = data?.data || [];

		return resultArray;
	} catch (error) {
		console.log('error!', error);

		return [];
	}
});

export const getEvent = createAction('GET_EVENT', async (eventId: number) => {
	try {
		const { v1WebEventsDetail } = api;
		const data = await v1WebEventsDetail(eventId);

		const resultArray = data?.data || undefined;

		return resultArray;
	} catch (error) {
		console.log('error!', error);

		return {};
	}
});

export const getGrModal = createAction('GET_GR_MODAL', async () => {
	try {
		const { v1WebGrModalList } = api;
		const data = await v1WebGrModalList({ secure: true });

		const resultArray = data?.data || undefined;

		return resultArray;
	} catch (error) {
		console.log('error!', error);

		return {};
	}
});

export interface State {
	loading: boolean;
	events: EventResource[];
	event: EventShowResource | undefined;
	grModal: GrModalResource[];
}

export const defaultState: State = {
	loading: false,
	events: [],
	event: undefined,
	grModal: [],
};

export const reducer = {
	events: handleActions<State, any>( // eslint-disable-line @typescript-eslint/no-explicit-any
		{
			GET_EVENTS_PENDING: state => ({
				...state,
				loading: true,
			}),

			GET_EVENTS_FULFILLED: (state, action) => ({
				...state,
				events: action.payload,
				loading: false,
			}),

			GET_EVENT_PENDING: state => ({
				...state,
				loading: true,
			}),

			GET_EVENT_FULFILLED: (state, action) => ({
				...state,
				event: action.payload,
				loading: false,
			}),

			GET_GR_MODAL_PENDING: state => ({
				...state,
				loading: true,
			}),

			GET_GR_MODAL_FULFILLED: (state, action) => ({
				...state,
				grModal: action.payload,
				loading: false,
			}),
		},
		defaultState,
	),
};

const eventActionsMap = {
	getEvents,
	getEvent,
	getGrModal,
};

const mapHooksToState = (state: GlobalState) => ({
	events: state.events.events,
	event: state.events.event,
	grModal: state.events.grModal,
});

type EventSelector = ReturnType<typeof mapHooksToState>;
type EventsActionsMap = typeof eventActionsMap;

export const useEvents = () =>
	useRedux<EventSelector, EventsActionsMap>(mapHooksToState, eventActionsMap);

/* +----------------------------------------------------------------------
	++ useTravelTour ++
++----------------------------------------------------------------------*/
// const selectEvent = (state: GlobalState) => state.events.event;

// export const useEvent = () => useRedux(selectEvent, { getEvent });
